import { render, staticRenderFns } from "./SelecionarPlanos.vue?vue&type=template&id=3fdbe578&scoped=true"
import script from "./SelecionarPlanos.vue?vue&type=script&lang=js"
export * from "./SelecionarPlanos.vue?vue&type=script&lang=js"
import style0 from "./SelecionarPlanos.vue?vue&type=style&index=0&id=3fdbe578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdbe578",
  null
  
)

export default component.exports